import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useChannelActions } from 'src/store/channel/actions';
import { RootState } from 'src/store/reducers/state';
import CourseQuizBuilderModal from 'src/components/admin/settings/pollAndQuiz/components/CourseQuizBuilderModal';
const AddNewCourseModal = ({ newChannelId, singleCourse }: any) => {
  const dispatch = useDispatch();
  const channelActions = useChannelActions(dispatch);
  const navigate = useNavigate();
  const { id } = useParams<string>();
  const ref = useRef<HTMLButtonElement>(null);
  const [showQuizBuilder, setShowQuizBuilder] = useState(false);
  const [view, setView] = useState<'menu' | 'quiz-select-video'>('menu');
  const [selectedVideoId, setSelectedVideoId] = useState<string>('');
  const { courseSequences } = useSelector((state: RootState) => {
    return {
      courseSequences: state.course.courseSequences
    };
  });

  const allVideos = (courseSequences?.contents ?? [])
    .flatMap((chapter: any) =>
      (chapter?.contentOrders ?? [])
        .filter((c: any) => c?.contentTypes === 1)
        .map((c: any) => ({ ...c, _chapterName: chapter?.chapterName }))
    )
    .filter(Boolean);

  const handleCloseClick = () => {
    setView('menu');
    setSelectedVideoId('');
    if (ref.current) ref.current.click();
  };

  const handleQuizClick = () => {
    if (ref.current) ref.current.click();
    setShowQuizBuilder(true);
  };

  const handleVideoUploadClick = (status: number) => {
    channelActions.getChannelListRequest();
    sessionStorage.setItem('returnUrl', window.location.pathname + window.location.search);
    navigate(`/add-video/${status}`, {
      state: { channelIds: singleCourse.channelId, from: 'course' }
    });
    handleCloseClick();
  };

  const handleResourceUploadClick = () => {
    channelActions.getChannelListRequest();
    sessionStorage.setItem('returnUrl', window.location.pathname + window.location.search);
    navigate('/add-resource', {
      state: { channelIds: singleCourse.channelId, from: 'course' }
    });
    handleCloseClick();
  };

  return (
    <>
      <div className="addNewCourse">
        <div
          className="videoViews modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto modal-open"
          id="addNewCourseModal"
          aria-labelledby="memberListModalLabel"
          aria-hidden="true">
          <div className="modal-dialog relative pointer-events-none min-w-[300px] max-w-[90%] mx-auto my-10">
            <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
              <div className="modal-header flex flex-shrink-0 items-center justify-between p-4 pb-2 rounded-t-md">
                <h5 className="text-xl font-semibold leading-normal text-center w-full" id="memberListModalLabel">
                  {view === 'menu' ? 'Add New' : 'Add Quiz – Select Video'}
                </h5>
                <button
                  ref={ref}
                  onClick={handleCloseClick}
                  type="button"
                  className="dismiss-btn"
                  data-bs-dismiss="modal"
                  aria-label="Close"></button>
              </div>
              <div className="modal-body p-4">
                {view === 'menu' ? (
                  <>
                    <div className="wrapper flex flex-wrap justify-center gap-6 mt-4 mb-4">
                      <div className="box-wrapper flex flex-col items-center cursor-pointer p-4 rounded-lg hover:bg-gray-200"
                        onClick={() => handleVideoUploadClick(0)}>
                        <i className="fa-solid fa-video fa-3x text-gray-600"></i>
                        <h6 className="mt-2 text-center">Video</h6>
                      </div>
                      <div className="box-wrapper flex flex-col items-center cursor-pointer p-4 rounded-lg hover:bg-gray-200"
                        onClick={handleResourceUploadClick}>
                        <i className="fa-solid fa-file fa-3x text-gray-600"></i>
                        <h6 className="mt-2 text-center">Resource</h6>
                      </div>
                    </div>
                    <div className="wrapper flex flex-wrap justify-center gap-6 mt-4 mb-4">
                      <div className="box-wrapper flex flex-col items-center cursor-pointer p-4 rounded-lg hover:bg-gray-200"
                        data-bs-toggle="modal" data-bs-target="#AddChapterModel">
                        <i className="fa-solid fa-file-text fa-3x text-gray-600"></i>
                        <h6 className="mt-2 text-center">Chapter</h6>
                      </div>
                      <div className="box-wrapper flex flex-col items-center cursor-pointer p-4 bg-gray-100 rounded-lg hover:bg-gray-200"
                        onClick={() => {
                          // navigate(`/checkpoint/${id}`);
                          // handleCloseClick();
                        }}>
                        <i className="fa-solid fa-check fa-3x text-gray-600"></i>
                        <h6 className="mt-2 text-center">Checkpoint</h6>
                      </div>
                      <div className="box-wrapper flex flex-col items-center cursor-pointer p-4 rounded-lg hover:bg-gray-200"
                        onClick={handleQuizClick}>
                        <i className="fa-solid fa-circle-question fa-3x text-gray-600"></i>
                        <h6 className="mt-2 text-center">Quiz</h6>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <button type="button"
                      className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-4"
                      onClick={() => { setView('menu'); setSelectedVideoId(''); }}>
                      <i className="fa-solid fa-arrow-left"></i>
                      <span>Back</span>
                    </button>
                    <p className="text-sm text-gray-600 mb-3">Select the video you want to add a quiz to:</p>
                    {allVideos.length === 0 ? (
                      <p className="text-sm text-gray-400 text-center py-6">No videos found in this course.</p>
                    ) : (
                      <ul className="divide-y divide-gray-100 max-h-60 overflow-y-auto rounded-lg border border-gray-200">
                        {allVideos?.length > 0 && allVideos.map((video: any) => (
                          <li key={video?.id}
                            className={`flex items-center gap-3 px-4 py-3 cursor-pointer transition-colors border-l-4 ${selectedVideoId === video?.id
                              ? 'bg-indigo-50 border-indigo-500'
                              : 'hover:bg-gray-50 border-transparent'
                              }`}
                            onClick={() => setSelectedVideoId(video?.id)}>
                            <i className={`fa-solid fa-circle-play text-lg ${selectedVideoId === video.id ? 'text-indigo-500' : 'text-gray-400'}`}></i>
                            <div className="flex flex-col min-w-0">
                              <span className={`text-sm font-medium truncate ${selectedVideoId === video.id ? 'text-indigo-700' : 'text-gray-700'}`}>
                                {video.name}
                              </span>
                              <span className="text-xs text-gray-400 truncate">{video._chapterName}</span>
                            </div>
                            {selectedVideoId === video.id && (
                              <i className="fa-solid fa-circle-check text-indigo-500 ml-auto"></i>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                    <div className="mt-5 flex justify-end">
                      <button type="button"
                        disabled={!selectedVideoId}
                        onClick={handleQuizClick}
                        className={`px-5 py-2 rounded-lg text-sm font-semibold transition-colors ${selectedVideoId ? 'bg-indigo-600 text-white hover:bg-indigo-700' : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                          }`}>
                        Add Quiz <i className="fa-solid fa-arrow-right ml-2"></i>
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <CourseQuizBuilderModal
        isOpen={showQuizBuilder}
        courseSequences={courseSequences}
        singleCourse={singleCourse}
        onClose={() => setShowQuizBuilder(false)}
      // onQuizSaved={() => {
      // }}
      />
    </>

  );
};

export default AddNewCourseModal;
